import {Injectable} from '@angular/core';
import {DeviceModel} from "../../models/grit/grit.device-model";
import {EndpointsService} from "../endpoints.service";
import {GritApiService} from "./grit.api.service";
import {ModalConfirmationService} from "../modal-confirmation.service";
import {UiBlockService} from "../ui-block.service";
import {ModalControlService} from "../modal-control.service";
import { Subscription, interval, takeWhile } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GritDeviceService {

  tabState : boolean = false;
  devices : DeviceModel[];

  constructor(
    private gritApiService : GritApiService,
    protected modalConfirmation: ModalConfirmationService,
    private uiBlock: UiBlockService,
    protected modalService: ModalControlService,
    private endpointsService: EndpointsService

  ) {
    const checkAuthSubscription: Subscription = interval(100) // ms
      .pipe(takeWhile(() => !this.endpointsService.httpOptions, true))
      .subscribe(() => {
        if (this.endpointsService.httpOptions) {
          checkAuthSubscription.unsubscribe();
          this.getDevices();
        }
      });

  }

  public toggleTab(open: boolean){
    this.tabState = open;
  }

  public getDevices() {
    this.gritApiService.deviceGetAll()
      .then(
        (response) => this.devices = response ?? [],
        (error) => console.log("Error getting devices type")
      );
  }

  importDevices(devices : DeviceModel[]){
    this.modalConfirmation.showMesssageConfirmationModal(
      "Import RFI-Transmitters",
      "Do you want to import the RFI-Transmitters?",
      "OK", "Cancel",
      () => {
        this.uiBlock.startBlock("Importing RFI-Transmitters")
        this.gritApiService.deviceCreate(devices).then(
          (devices) => {
            this.devices.push(...devices);
            this.modalService.showMesssageModal('Import Success', "RFI-Transmitters were successfully imported.");
          },
          (error) => {
            console.error(error)
            this.modalService.showMesssageModal('Import Failed', "Failed importing RFI-Transmitters. Check if structure is equal to export.");
          }
        ).finally(()=>this.uiBlock.stopBlock())
      }
    );
  }
}
